import React, { createContext, useState } from 'react';

const ServicesPageContext = createContext(null);

interface ServicePageProviderProps {
  children: React.ReactNode;
  packageInfo?: {
    packageType?: string;
    currentPackage?: string;
  };
}

export const ServicesPageProvider : React.FC<ServicePageProviderProps> = ({
  children, packageInfo,
} : ServicePageProviderProps) => {
  const [packageType, setPackageType] = useState('one-time');
  const [currentPackage, setCurrentPackage] = useState('deep-cleaning');
  const [activeRoom, setActiveRoom] = useState(null);

  const selectPackageType = (event) => {
    const eventTarget: HTMLElement = event.target;

    if (eventTarget.dataset.value !== packageType) {
      setCurrentPackage(null);
      setActiveRoom(null);
    }

    setPackageType(eventTarget.dataset.value);
  };

  return (
    <ServicesPageContext.Provider value={{
      packageType,
      setPackageType,
      currentPackage,
      setCurrentPackage,
      activeRoom,
      setActiveRoom,
      selectPackageType,
    }}
    >
      {children}
    </ServicesPageContext.Provider>
  );
};

ServicesPageProvider.defaultProps = {
  packageInfo: {
    packageType: null,
    currentPackage: null,
  },

};

export default ServicesPageContext;
